import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestMedicineComponent } from './request-medicine.component';
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MaterialModule} from "../../../material/material.module";
import {DropZoneModule} from "../drop-zone/drop-zone.module";
import {GeneralDropdownModule} from "../../components/general-dropdown/general-dropdown.module";



@NgModule({
  declarations: [
    RequestMedicineComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        DropZoneModule,
        GeneralDropdownModule,
    ],
  exports:[
    RequestMedicineComponent
  ]
})
export class RequestMedicineModule { }
